// src/components/OnboardingGate.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { resolveEmployerOnboardingPath } from "../utils/onboardingRouter";

/**
 * Mount this once near the top of your app (e.g., in App.jsx).
 * It silently checks the user's onboarding progress and navigates them to
 * the correct screen if they're mid-flow and re-open the site later.
 */
export default function OnboardingGate() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) return;

    // 👉 Only run the employer onboarding gate
    if (user.role !== "employer") return;

    // ✅ PAUSE gate while CompanySetup overlay is running
    const inProgress =
      localStorage.getItem("oiiko_setup_in_progress") === "true";
    if (inProgress) {
      const startedAt = Number(
        localStorage.getItem("oiiko_setup_started_at") || 0
      );
      // Allow up to 20s of "pause", then recover
      if (!startedAt || Date.now() - startedAt < 20000) return;

      // safety cleanup
      localStorage.removeItem("oiiko_setup_in_progress");
      localStorage.removeItem("oiiko_setup_started_at");
    }

    (async () => {
      try {
        const dest = await resolveEmployerOnboardingPath();
        if (!dest) return;

        // Avoid loops
        if (location.pathname !== dest) navigate(dest, { replace: true });
      } catch (e) {
        console.warn("OnboardingGate failed:", e);
      }
    })();
  }, [user, loading, navigate, location.pathname]);

  return null;
}
